import * as paymentsActions from '../../actions/hardwareActions/constants'

const initialState = {
    rates: null,
    isLoadRates: false,
    payments: null,
    invoices: null,
    currentInvoice: null,
    isLoading: true,
    isPaymentEditing: false,
    isLoadingStatistic: true,
    statistic: null,
    isBulkUpdating: false,
    totals: null,
    isLoadingTotals: true
};

export default (state = initialState, action) => {
    switch (action.type) {
        case paymentsActions.SET_DEFAULT_HARDWARE_PAYMENTS:
            return {
                ...state,
                payments: null,
                isLoading: true,
            };
        case paymentsActions.GET_RATES_REQUEST:
            return {
                ...state,
                isLoadRates: true,
            };
        case paymentsActions.GET_RATES_SUCCESS:
            return {
                ...state,
                isLoadRates: false,
                rates: action.payload,
            };
        case paymentsActions.GET_RATES_FAILURE:
            return {
                ...state,
                rates: null,
                isLoadRates: false,
            };
        case paymentsActions.GET_HARDWARE_TOTALS_REQUEST:
            return {
                ...state,
                isLoadingTotals: true,
            };
        case paymentsActions.GET_HARDWARE_TOTALS_SUCCESS:
            return {
                ...state,
                isLoadingTotals: false,
                totals: action.payload,
            };
        case paymentsActions.GET_HARDWARE_TOTALS_FAILURE:
            return {
                ...state,
                totals: null,
                isLoadingTotals: false,
            };
        case paymentsActions.GET_HARDWARE_PAYMENTS_REQUEST:
            return {
                ...state,
                isLoading: true,
            };
        case paymentsActions.GET_HARDWARE_PAYMENTS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                payments: action.payload,
            };
        case paymentsActions.GET_HARDWARE_PAYMENTS_FAILURE:
            return {
                ...state,
                payments: null,
                isLoading: false,
            };
        case paymentsActions.UPDATE_HARDWARE_PAYMENT_DATA_REQUEST:
            return {
                ...state,
                isPaymentEditing: true,
            };
        case paymentsActions.UPDATE_HARDWARE_PAYMENT_DATA_SUCCESS:
            return {
                ...state,
                isPaymentEditing: false,
            };
        case paymentsActions.UPDATE_HARDWARE_PAYMENT_DATA_FAILURE:
            return {
                ...state,
                isPaymentEditing: false,
            };
        default:
            return state
    }
}